/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BankAccountWaitFor = {
  PaymentMethod: "payment-method",
  RailResponse: "rail-response",
} as const;
export type BankAccountWaitFor = ClosedEnum<typeof BankAccountWaitFor>;

/** @internal */
export const BankAccountWaitFor$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountWaitFor
> = z.nativeEnum(BankAccountWaitFor);
/** @internal */
export const BankAccountWaitFor$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountWaitFor
> = BankAccountWaitFor$inboundSchema;
